import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { CListRow, Text } from "@appcues/component-library";
import { logOut } from "actions/user";
import { MULTI_APP_ENABLED } from "constants/features";
import { selectAccountFeature } from "reducers/account/features";
import { selectHasMultipleAccounts } from "reducers/accounts";

export const NavbarMenu = ({ label, onLogout, hasMultiAppEnabled = false }) => (
  <CListRow.Menu>
    <CListRow.Menu.Section>
      {hasMultiAppEnabled && (
        <CListRow is={Link} to="/accounts" paddingY={20}>
          <Text bold truncate>
            {label}
          </Text>
          <Text type="tertiary" fontSize={12} paddingTop={4}>
            Switch accounts
          </Text>
        </CListRow>
      )}

      {!hasMultiAppEnabled && (
        <CListRow paddingY={20}>
          <Text bold truncate>
            {label}
          </Text>
        </CListRow>
      )}
    </CListRow.Menu.Section>
    <CListRow.Menu.Section>
      <CListRow is={Link} to="/settings" beforeIcon="fas fa-cog">
        Settings
      </CListRow>
    </CListRow.Menu.Section>
    <CListRow.Menu.Section>
      <CListRow
        is="a"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.appcues.com/whats-new"
      >
        Whats New
      </CListRow>
      <CListRow
        is="a"
        rel="noopener noreferrer"
        target="_blank"
        href="https://docs.appcues.com/"
      >
        Appcues Docs
      </CListRow>
      <CListRow
        is="a"
        rel="noopener noreferrer"
        target="_blank"
        href="https://status.appcues.com/"
      >
        Status Page
      </CListRow>
    </CListRow.Menu.Section>
    <CListRow.Menu.Section>
      <CListRow afterIcon="fas fa-sign-out-alt" onClick={onLogout}>
        Sign out
      </CListRow>
    </CListRow.Menu.Section>
  </CListRow.Menu>
);

NavbarMenu.propTypes = {
  hasMultiAppEnabled: PropTypes.bool,
  label: PropTypes.string,
  onLogout: PropTypes.func
};

const mapStateToProps = state => ({
  hasMultiAppEnabled:
    selectHasMultipleAccounts(state) ||
    selectAccountFeature(state, MULTI_APP_ENABLED)
});

const mapDispatchToProps = {
  onLogout: logOut
};

export default connect(mapStateToProps, mapDispatchToProps)(NavbarMenu);
